import { useEffect } from 'react';
import { observable, runInAction } from 'mobx';

export interface BookingSummaryStateValues {
    collapsable: boolean;
    open: boolean;
    mounted: boolean;
    isPartnerBooking: boolean;
}

export interface BookingSummaryState extends BookingSummaryStateValues {
    setCollapsable: (collapsable: boolean) => void;
    setOpen: (open: boolean) => void;
    setMounted: (mounted: boolean) => void;
    toggle: () => void;
    reset: () => void;
}

export const bookingSummaryState: BookingSummaryState = observable({
    collapsable: false,
    open: false,
    mounted: false,
    isPartnerBooking: false,
    setCollapsable: (collapsable) => runInAction(() => (bookingSummaryState.collapsable = collapsable)),
    setOpen: (open) => runInAction(() => (bookingSummaryState.open = open)),
    toggle: () => runInAction(() => (bookingSummaryState.open = !bookingSummaryState.open)),
    setMounted: (mounted) => runInAction(() => (bookingSummaryState.mounted = mounted)),
    reset: () => {
        runInAction(() => {
            bookingSummaryState.collapsable = false;
            bookingSummaryState.open = false;
            bookingSummaryState.mounted = false;
        });
    },
});

export const useBookingSummaryState = ({ collapsable, open, isPartnerBooking }: Partial<BookingSummaryStateValues>) => {
    useEffect(() => {
        bookingSummaryState.setCollapsable(Boolean(collapsable));
    }, [collapsable]);

    useEffect(() => {
        if (open !== undefined) {
            bookingSummaryState.setOpen(open);
        }
    }, [open]);

    useEffect(() => {
        runInAction(() => (bookingSummaryState.isPartnerBooking = Boolean(isPartnerBooking)));
    }, [isPartnerBooking]);

    useEffect(() => {
        bookingSummaryState.setMounted(true);
    }, []);
};
